import React from 'react'
import { TiArrowUnsorted } from "react-icons/ti";

interface Column<T> {
    label: string;
    accessor: keyof T;
    sortable?: boolean;
    render?: (value: T[keyof T], row: T) => React.ReactNode;
    getValue?: (row: T) => any;
}

interface TableProps<T> {
    columns: Column<T>[];
    data: T[];
    bgColorTr?: string;
    colorTr?: string;
    onSort?: (key: keyof T) => void;
    firstColumnWidth?: string;
}

const CustomTable = <T,>({
    columns,
    data,
    bgColorTr = '#FFFFFF',
    colorTr = 'text-primary-10',
    onSort,
    firstColumnWidth = 'w-xl',
}: TableProps<T>) => {

    return (
        <div className="overflow-hidden rounded-sm border border-system-primary-20">
            <table className="min-w-full bg-white border-separate border-spacing-0 table-fixed">
                <colgroup>
                    {columns.map((column, colIndex) => (
                        <col
                            key={String(column.accessor)}
                            className={colIndex === 0 ? firstColumnWidth : ''}
                        />
                    ))}
                </colgroup>
                <thead className="bg-gray-200">
                    <tr className={`${bgColorTr} ${colorTr}`}>
                        {columns.map((column, colIndex) => {
                            return (
                                <th
                                    key={String(column.accessor)}
                                    onClick={() => column.sortable && onSort?.(column.accessor)}
                                    className={`p-4 border-b border-system-primary-20 text-llarge text-gray-600 
                                        ${colIndex === 0 ? 'text-left' : 'text-center'} 
                                        ${column.sortable ? 'cursor-pointer select-none' : ''}
                                    `}
                                >
                                    <div className={`${column.sortable ? 'flex gap-1 items-center justify-center' : ''}`}>
                                        {column.sortable && (
                                            <TiArrowUnsorted size={16} color={colorTr} />
                                        )}
                                        <span>{column.label.toUpperCase()}</span>
                                    </div>
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((column, colIndex) => (
                                <td
                                    key={String(column.accessor)}
                                    className={`py-2 px-4 border-b border-system-primary-20 text-gray-800 
                                        ${colIndex === 0 ? 'text-left' : 'text-center'}`}
                                >
                                    {column.render
                                        ? column.render(row[column.accessor], row)
                                        : String(row[column.accessor])}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CustomTable;